import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { Webhook } from '../models/webhook.model';
import { SearchParams } from '../commons/abstract.types';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WebhookService extends AbstractService<Webhook> {

  getURLBase(): string {
    return '/webhook';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Webhook): void {
    delete obj?._id;
  }
  preUpdate(obj: Webhook): void {
  }

  pagerByCodeAndUUID(page: number, perPage: number, search?: string, params?: Partial<SearchParams>) {
    const baseURL = `/pager/by/code/uuid`;
    const pagering = `${baseURL}?page=${page}&perPage=${perPage}`;

    const getSearchConfig = (search: string): string => {
      if (!!search) {
        return '&search=' + encodeURIComponent(search);
      } else {
        return '';
      }
    }
    const searching = `${pagering}${getSearchConfig(search)}`;

    let urling = `${searching}`;
    if (!!params) {
      for (let param in params) {
        urling = `${urling}&${param}=${params[param]}`;
      }
    }
    return super.get(urling);
  }

  getCountTotalWebhooks(codeCompany: string): Observable<number> {
    return super.get(`/total/${codeCompany}`);
  }

  getEventsByUUID(uuid: string): Observable<Array<Webhook>> {
    return super.get(`/events/by/uuid/${uuid}/`);
  }

}  